import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import vbclass from 'vue-body-class'

const VueRouter = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/services',
      name: 'services',
      component: () => import('./views/Services.vue')
    },
    {
      path: '/cases',
      name: 'cases',
      meta: { bodyClass: 'dark' },
      component: () => import('./views/Cases.vue')
    },
    {
      path: '/cases/eton',
      name: 'eton',
      meta: { bodyClass: 'case eton' },
      component: () => import('./views/cases/Eton.vue')
    },
    {
      path: '/cases/asket',
      name: 'asket',
      meta: { bodyClass: 'case asket' },
      component: () => import('./views/cases/Asket.vue')
    },
    {
      path: '/cases/happysocks',
      name: 'happysocks',
      meta: { bodyClass: 'case happysocks' },
      component: () => import('./views/cases/HappySocks.vue')
    },
    {
      path: '/join-us',
      name: 'join-us',
      component: () => import('./views/JoinUs.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      meta: { bodyClass: 'dark' },
      component: () => import('./views/Contact.vue')
    }
  ],
  scrollBehavior () {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 500)
    })
  }
})

export default VueRouter

Vue.use(Router)
Vue.use(vbclass, VueRouter)
